import { render, staticRenderFns } from "./add-high-seas-info.vue?vue&type=template&id=ded0a58a&scoped=true&"
import script from "./add-high-seas-info.vue?vue&type=script&lang=js&"
export * from "./add-high-seas-info.vue?vue&type=script&lang=js&"
import style0 from "./add-high-seas-info.vue?vue&type=style&index=0&id=ded0a58a&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded0a58a",
  null
  
)

export default component.exports